import Axios, { AxiosInstance } from 'axios';

const APP_API_BASE_URL = '/.netlify/functions';
class AppService {
    server: AxiosInstance;
    constructor() {
        this.server = Axios.create({
            baseURL: APP_API_BASE_URL,
            timeout: 40000,
        });
    }
    signInSpotifyApp() {
        return this.server.get(`${APP_API_BASE_URL}/sign-in-spotify-app`);
    }
    signIn() {
        window.location.href = `${APP_API_BASE_URL}/sign-in`;
    }
    signOut() {
        return this.server.post('/sign-out');
    }
    refreshSpotifyUserAccessToken() {
        return this.server.get('/token');
    }
    getAccessToken(code: string, state: string) {
        return this.server.get(`/callback?code=${code}&state=${state}`);
    }
    signInSpotifyGuest() {
        window.location.href = `${APP_API_BASE_URL}/sign-in-spotify-guest`;
    }
    getSpotifyGuestAccessToken(code: string, state: string) {
        return this.server.get(`/callback-spotify-guest?code=${code}&state=${state}`);
    }
}

export default new AppService();
